import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex min-h-full w-full flex-col bg-white" data-id="element-63" data-mp="kzvfhkw84wcz">
      <Header data-id="element-64" data-mp="zwcs0fg5gh14" />
      <main className="flex-1" data-id="element-65" data-mp="zwvzt3c35p1f">
        <Outlet data-id="element-66" data-mp="zv1o8fmpf9a0" />
      </main>
      <Footer data-id="element-67" data-mp="uxrtqlkgk7fb" />
    </div>;
}